
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11447',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11447",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.444",
  "data-fetching-client": "static-1.9439",
  "graphql": "static-1.76",
  "head-dlb": "static-1.4754",
  "hs-test-utils": "static-1.7767",
  "hub-http-shared-msw-handlers": "static-1.9383",
  "hubspot-dlb": "static-2.1796",
  "hubspot-url-utils": "static-1.3917",
  "HubStyleTokens": "static-2.11184",
  "I18n": "static-7.1558",
  "jasmine-runner": "static-1.6235",
  "marketplace-storefront-base": "static-1.11507",
  "quartz": "static-1.6676",
  "react-dlb": "static-1.71",
  "customer-data-property-utils": "static-1.7834",
  "foundations-components": "static-1.7444",
  "foundations-theming": "static-1.4171",
  "history": "static-4.47",
  "hub-http": "static-1.5966",
  "integrations-lib": "static-1.15290",
  "marketplace-ui-common": "static-1.18845",
  "PortalIdParser": "static-2.349",
  "property-management-iframe": "static-1.12162",
  "quartz-config": "static-1.454",
  "quartz-core": "static-1.5895",
  "quartz-routing": "static-1.106",
  "quick-fetch": "static-1.3698",
  "react": "static-7.177",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16403",
  "react-router-dom": "static-5.26",
  "rpc-client-utils": "static-1.4393",
  "SharedI18nStrings": "static-1.180",
  "trellis-ecosystem": "static-1.6651",
  "ts-schema": "static-1.3870",
  "ui-addon-i18n": "static-1.10893",
  "ui-addon-react-router-dom": "static-1.9309",
  "ui-universal-auth": "static-1.8639",
  "UIComponents": "static-3.8131",
  "usage-tracker": "static-1.7095",
  "usage-tracker-core": "static-1.6945",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.387",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9391",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "styled-components": "static-2.84",
  "bend-plugin-trellis-migration": "static-1.3192",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2953",
  "quartz-webpack": "static-1.2900",
  "fast-json-stable-stringify": "static-1.4",
  "HeadJS": "static-2.701",
  "framer-motion": "static-1.66",
  "hs-test-utils-bend-plugin": "static-1.2878",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.77",
  "react-utils": "static-2.5140",
  "StyleGuideUI": "static-3.483",
  "jasmine": "static-4.4092",
  "ai-components-ui-library": "static-1.8241",
  "ai-rendering-library": "static-1.9183",
  "amplitude-session-replay-browser": "static-1.54",
  "chirp-fetch": "static-1.1645",
  "connections-embed-lib": "static-1.565",
  "copilot-toolkit": "static-1.10423",
  "foundations-assets": "static-1.4594",
  "hs-lodash": "static-4.45",
  "laboratory-lib": "static-3.6925",
  "marketplace-embed": "static-1.21376",
  "marketplace-ui-apps-core": "static-1.17378",
  "marketplace-ui-assets-core": "static-1.18782",
  "marketplace-ui-client-types": "static-1.16252",
  "marketplace-ui-details": "static-1.8741",
  "marketplace-ui-reviews": "static-1.18801",
  "marketplace-ui-tracking": "static-1.13016",
  "sanitize-text": "static-1.7902",
  "ui-addon-video-player": "static-1.8456",
  "usage-tracker-multi": "static-1.5509",
  "usage-tracker-session-replay": "static-1.4781",
  "wootric-nps": "static-1.6737",
  "customer-data-objects": "static-1.7405",
  "property-translator": "static-1.5176",
  "bend-plugin-foundations-components": "static-1.3713",
  "floating-ui": "static-1.50",
  "foundations-theming-specialty": "static-1.1887",
  "hs-story-utils": "static-1.9189",
  "react-aria": "static-1.60",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.93",
  "tanstack-table": "static-1.49",
  "trellis-assets": "static-1.1086",
  "ui-fonts": "static-1.446",
  "ui-images": "static-2.1082",
  "bend-plugin-foundations-theming": "static-1.2654",
  "foundations-theming-base": "static-1.3156",
  "stylex": "static-1.26",
  "flux-actions": "static-1.302",
  "frontend-preferences-client": "static-1.7689",
  "hs-promise-utils": "static-1.5353",
  "hubspot-apollo-client": "static-1.4641",
  "integrations-error-boundary-lib": "static-1.12705",
  "integrations-tracking-lib": "static-1.5346",
  "native-integrations-shared-strings": "static-1.7551",
  "quartz-i18n": "static-1.351",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10135",
  "reselect": "static-2.16",
  "rxjs": "static-5.10",
  "sanitize": "static-1.4237",
  "superstore": "static-1.4534",
  "ui-shepherd-react": "static-3.9907",
  "ai-settings-ui-library": "static-1.7321",
  "hub-http-janus": "static-1.784",
  "hubspotter-http": "static-1.4444",
  "immer": "static-1.33",
  "immutable-less": "static-1.4416",
  "nav-meta": "static-1.28778",
  "react-window": "static-1.13",
  "self-service-api": "static-1.9999",
  "ui-addon-upgrades": "static-9.17593",
  "inbound-db-properties-service-client": "static-1.3642",
  "property-management-common": "static-1.4449",
  "ui-addon-iframeable": "static-1.8803",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "icons": "static-2.618",
  "mobile-manifest-mixins": "static-1.474",
  "quartz-auth": "static-1.351",
  "quartz-head": "static-1.341",
  "quartz-test": "static-1.351",
  "usage-tracker-container": "static-1.7085",
  "csstype": "static-1.50",
  "storybook-react": "static-1.27",
  "trellis-story-utils": "static-1.4283",
  "foundations-components-test-utils": "static-1.4927",
  "react-input-autosize": "static-2.17",
  "cssUtils": "static-1.720",
  "HubStyle": "static-2.11492",
  "bender-build-tools": "static-1.2899",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20157",
  "ContentUtils": "static-1.67508",
  "sassPrefix": "static-1.151",
  "avatar-components": "static-1.2248",
  "customer-data-filters-ui": "static-1.38739",
  "customer-data-objects-ui-components": "static-1.12764",
  "customer-data-reference-ui-components": "static-1.12903",
  "embedded-academy-lib": "static-1.13370",
  "ExportDialog": "static-6.10150",
  "highlight.js": "static-1.73",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40537",
  "reporting-data": "static-1.66351",
  "reporting-snowflake": "static-1.54969",
  "reporting-ui-components": "static-2.63623",
  "reporting-visualizations": "static-1.58427",
  "ui-addon-teams": "static-1.21188",
  "magpie-lib": "static-1.5356",
  "magpie-types": "static-1.4816",
  "simple-logging-lib": "static-1.2813",
  "navigation-components": "static-1.17141",
  "navigation-messaging": "static-1.6468",
  "developer-experience-shared-components": "static-1.10218",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7746",
  "ui-extensibility-client-types": "static-1.3711",
  "signup-constants": "static-1.18309",
  "signup-ui-url-generator": "static-2.7824",
  "ai-studio-lib": "static-1.10884",
  "ui-tool-access": "static-1.9906",
  "usage-based-billing-components-lib": "static-1.7913",
  "usage-tracker-anonymous": "static-1.5512",
  "usage-tracker-public": "static-1.6906",
  "apollo-link-hub-http": "static-2.4411",
  "hubspot-apollo-cache": "static-1.100",
  "universal-page-editor-lib": "static-1.2761",
  "redux-toolkit": "static-1.7",
  "merchandise-lib": "static-1.257",
  "atom": "static-1.4833",
  "purchase-motions-components": "static-1.5427",
  "salesImages": "static-1.520",
  "upgrade-management-service-types": "static-1.4270",
  "batch-promise": "static-1.1312",
  "crm-component-utils": "static-1.38386",
  "crm-properties-common-lib": "static-1.5634",
  "framework-data-schema-resolvers": "static-1.6632",
  "inbound-db-meta-service-client": "static-1.3397",
  "reference-resolvers-lite": "static-1.7852",
  "hubspotter-http-shared-msw-handlers": "static-1.9381",
  "cms-field-types": "static-1.4569",
  "content-icons-ui": "static-1.2141",
  "underscore": "static-1.8",
  "conversations-skeleton-state": "static-1.7011",
  "crm-message-bus": "static-1.42234",
  "customer-data-filters-ui-msw-helpers": "static-1.21173",
  "customer-data-ui-utilities": "static-1.9587",
  "FormUrlGenerator": "static-2.4493",
  "framework-builder-read-service-client": "static-1.3813",
  "framework-data-schema-quick-fetch": "static-1.6537",
  "multi-account-reference-resolvers": "static-1.731",
  "onboarding-tours": "static-1.16206",
  "PatternValidationJS": "static-1.437",
  "react-immutable-proptypes": "static-2.8",
  "reference-resolvers": "static-1.7922",
  "reporting-datasets-permissions-lib": "static-1.12933",
  "academy-common-lib": "static-1.12830",
  "content-assistance-lib": "static-1.7389",
  "dashboard-lib": "static-1.80455",
  "file-manager-components": "static-1.22770",
  "getting-started-shared-tasks": "static-1.17771",
  "hubspot-prosemirror": "static-1.17494",
  "hubspot-prosemirror-plugins": "static-1.17486",
  "prosemirror": "static-1.13",
  "react-colorpicker": "static-2.9974",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "rich-text-lib": "static-1.19406",
  "share-with-third-party-component-lib": "static-1.8452",
  "ui-addon-draggable": "static-3.4527",
  "ui-asset-management-lib": "static-1.10658",
  "ui-business-units-lib": "static-1.8785",
  "user-context": "static-1.4857",
  "persist-promise": "static-1.3469",
  "reporting-client-types": "static-1.2372",
  "growth-payments-core": "static-1.24615",
  "highcharts": "static-8.98",
  "reporting-plugins": "static-1.9933",
  "reporting-reports": "static-1.66029",
  "idb-keyval": "static-1.38",
  "reactive-lib": "static-1.488",
  "apps-service-types": "static-1.3641",
  "oauth-service-types": "static-1.4002",
  "codemirror": "static-5.89",
  "feedback-loader": "static-1.28778",
  "react-codemirror": "static-1.10390",
  "onboarding-scopes": "static-1.6227",
  "onboarding-tours-client": "static-1.4420",
  "platform-infra-nav-components": "static-1.7458",
  "subscription-experience-data-types": "static-1.14536",
  "crm-record-cards-service-types": "static-1.3417",
  "location-customization-utils-lib": "static-1.8435",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4286",
  "nav-client-types": "static-1.2117",
  "purchase-motions-api": "static-1.5430",
  "trials-service-types": "static-1.3687",
  "card-properties-lib": "static-1.43413",
  "crm-actions": "static-1.6057",
  "crm-cards-data": "static-1.1130",
  "crm-cards-sdk": "static-1.42798",
  "customer-data-properties": "static-1.50666",
  "customer-data-properties-shared-msw-handlers": "static-1.8710",
  "customer-data-tracking": "static-1.6644",
  "conditional-properties-service-client": "static-1.3589",
  "crm-pipelines-api-client-types": "static-1.3930",
  "multi-currency-client-types": "static-1.3484",
  "external-options-client-types": "static-1.3949",
  "react-dnd-compat": "static-1.4385",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5116",
  "growth-onboarding-confetti": "static-1.2832",
  "growth-onboarding-next-action-utils": "static-1.1257",
  "onboarding-tours-utils": "static-1.272",
  "ui-shepherd-tracker": "static-1.7288",
  "academy-service-client": "static-1.3444",
  "final-form": "static-1.64",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.27840",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8149",
  "immerable": "static-1.3917",
  "video-components-external": "static-1.10460",
  "video-data-lib": "static-1.34118",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8330",
  "payment-link-components": "static-1.22828",
  "ui-addon-emoji-picker": "static-1.9652",
  "EmailSignatureEditor": "static-1.23859",
  "viral-links-lib": "static-1.6789",
  "data-token-picker": "static-1.15980",
  "FileManagerLib": "static-1.38410",
  "react-flip-move": "static-1.64",
  "timezone-utils": "static-2.5006",
  "getting-started-shared-tasks-store": "static-1.16889",
  "campaign-roi-lib": "static-1.8168",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.152",
  "eligibility-engine-service-types": "static-1.2968",
  "crm_data": "static-4.91089",
  "crm-links": "static-1.6016",
  "customer-data-sidebar": "static-2.45308",
  "enrichment-properties-lib": "static-1.14857",
  "crm-fe-perf": "static-1.22669",
  "calling-global-api": "static-1.63527",
  "calling-internal-common": "static-1.31053",
  "calling-lifecycle-internal": "static-1.64909",
  "calling-lifecycle-messages": "static-1.57203",
  "commerce-products-lib": "static-1.8735",
  "google-libphonenumber": "static-1.32",
  "hs-entities": "static-1.432",
  "inbounddb-objects-service-types": "static-1.4016",
  "meetings-icalendar-utils-lib": "static-1.396",
  "object-builder-ui-client": "static-1.47842",
  "pipeline-validation-client-types": "static-1.3753",
  "property-value-citations": "static-1.1280",
  "pulse": "static-1.262",
  "smart-property-lib": "static-1.5739",
  "tiered-pricing": "static-1.773",
  "ui-addon-form-validation": "static-1.10757",
  "growth-onboarding-feedback-components": "static-1.6347",
  "content-media-composition-data-lib": "static-1.11310",
  "content-media-compositions": "static-2.15317",
  "media-bridge-lib": "static-1.18502",
  "commerce-tours-lib": "static-1.5663",
  "growth-onboarding-reliability": "static-1.4851",
  "sales-checkout-service-client": "static-1.3439",
  "draft-convert": "static-2.31",
  "draft-extend": "static-3.69",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21244",
  "sales-email-signature-service-client": "static-1.3605",
  "audio-components": "static-1.5554",
  "FileManagerCore": "static-1.38269",
  "FileManagerImages": "static-1.35921",
  "video-components": "static-1.12463",
  "crm_universal": "static-1.21596",
  "customer-data-email": "static-1.17603",
  "calling-error-reporting": "static-1.31059",
  "card-payment-highlight-lib": "static-1.36396",
  "card-subscription-highlight-lib": "static-1.38751",
  "commerce-billing-lib": "static-1.18389",
  "commerce-contract-lib": "static-1.11020",
  "customer-data-content": "static-1.26806",
  "invoices-highlight-card-lib": "static-1.53880",
  "orders-highlight-card-lib": "static-1.20778",
  "products-highlight-card-lib": "static-1.17019",
  "project-storage": "static-1.4495",
  "quotes-highlight-card-lib": "static-1.71015",
  "breeze-intelligence-kit": "static-1.5261",
  "crm-source-interpretation-lib": "static-1.5094",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9466",
  "fsm": "static-1.3494",
  "policy-lib": "static-1.6547",
  "shared-worker-versioning": "static-1.10800",
  "calling-usage-tracker": "static-1.6301",
  "voice-sms-access-library": "static-1.122",
  "products-iframe-lib": "static-1.7211",
  "products-ui-components-shared-msw-handlers": "static-1.9765",
  "directed-graph": "static-1.699",
  "event-emitter": "static-1.710",
  "react-tinymce": "static-1.54516",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9529",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53642",
  "tinymce-plugins": "static-1.56756",
  "tinymce-themes": "static-1.55612",
  "hls.js": "static-1.33",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4295",
  "video-embed": "static-1.34952",
  "social-insights-client-types": "static-1.21246",
  "sequences-lib": "static-1.7627",
  "ui-gdpr-components": "static-1.10109",
  "commerce-shared-components-lib": "static-1.17818",
  "commerce-subscription-lib": "static-1.36328",
  "commerce-tools-ui-lib": "static-1.9697",
  "utility-belt": "static-1.2304",
  "payments-enrollment-embed-lib": "static-1.21840",
  "products-ui-components": "static-1.39254",
  "quotes-client-types": "static-1.37103",
  "quotes-ui-lib": "static-1.79734",
  "SalesContentIndexUI": "static-3.8845",
  "accounting-integrations-ui-components": "static-1.6665",
  "invoices-ui-lib": "static-1.53896",
  "commerce-products-api": "static-1.1900",
  "SafeStorage": "static-1.4167",
  "invoices-iframe-lib": "static-1.55954",
  "quotes-modal-lib": "static-1.101691",
  "calling-orchestration-schema": "static-1.34899",
  "sales-views-client-types": "static-1.4054",
  "hub-http-contrib": "static-1.2807",
  "interframe": "static-3.4554",
  "tinymce-data": "static-1.39727",
  "ui-addon-sales-email": "static-1.4975",
  "layout-dnd-components": "static-1.11961",
  "layout-dnd-utils": "static-1.10936",
  "ui-brand-identity-lib": "static-1.13677",
  "NamespacedHubStyle": "static-2.8862",
  "outpost": "static-1.3969",
  "sequences-client-types-lib": "static-1.7484",
  "customer-data-associations": "static-1.7097",
  "framework-data-table": "static-2.11325",
  "customer-data-rte": "static-1.32353",
  "cv-backend-services": "static-1.1484",
  "growth-onboarding-empty-states": "static-1.5304",
  "InboxConnectUtils": "static-4.14124",
  "payments-post-enroll-local-storage-lib": "static-1.4875",
  "qrcode-generator": "static-1.63",
  "stripe-embedded-components": "static-1.7069",
  "commerce-permissions": "static-1.514",
  "commerce-tax-lib": "static-1.268",
  "property-description-translator": "static-1.3622",
  "FireAlarmUi": "static-1.4293",
  "sales-templates-service-types-lib": "static-1.3959",
  "commerce-analytics-service-client": "static-1.3427",
  "totals-ui-components": "static-1.22902",
  "ContentData": "static-1.67583",
  "layout-data-lib": "static-1.9261",
  "deal-intel-decorators": "static-1.1111",
  "tanstack-virtual": "static-1.24",
  "draft-content-plugins": "static-1.27622",
  "stripe-connect-js": "static-1.63",
  "commerce-totals-service-types": "static-1.3604",
  "advanced-menus-core": "static-1.14758",
  "advanced-menus-lib": "static-1.11741",
  "ui-memberships-settings-lib": "static-1.33324",
  "deal-intel-utils": "static-1.1115",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14757",
  "simple-menus-lib": "static-1.16274"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11447",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.444",
  "data-fetching-client": "/data-fetching-client/static-1.9439",
  "graphql": "/graphql/static-1.76",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-test-utils": "/hs-test-utils/static-1.7767",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9383",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyleTokens": "/HubStyleTokens/static-2.11184",
  "I18n": "/I18n/static-7.1558",
  "jasmine-runner": "/jasmine-runner/static-1.6235",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11507",
  "quartz": "/quartz/static-1.6676",
  "react-dlb": "/react-dlb/static-1.71",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7834",
  "foundations-components": "/foundations-components/static-1.7444",
  "foundations-theming": "/foundations-theming/static-1.4171",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.5966",
  "integrations-lib": "/integrations-lib/static-1.15290",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.18845",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "property-management-iframe": "/property-management-iframe/static-1.12162",
  "quartz-config": "/quartz-config/static-1.454",
  "quartz-core": "/quartz-core/static-1.5895",
  "quartz-routing": "/quartz-routing/static-1.106",
  "quick-fetch": "/quick-fetch/static-1.3698",
  "react": "/react/static-7.177",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16403",
  "react-router-dom": "/react-router-dom/static-5.26",
  "rpc-client-utils": "/rpc-client-utils/static-1.4393",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6651",
  "ts-schema": "/ts-schema/static-1.3870",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10893",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9309",
  "ui-universal-auth": "/ui-universal-auth/static-1.8639",
  "UIComponents": "/UIComponents/static-3.8131",
  "usage-tracker": "/usage-tracker/static-1.7095",
  "usage-tracker-core": "/usage-tracker-core/static-1.6945",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.387",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9391",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.84",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3192",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2953",
  "quartz-webpack": "/quartz-webpack/static-1.2900",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "HeadJS": "/HeadJS/static-2.701",
  "framer-motion": "/framer-motion/static-1.66",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2878",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.77",
  "react-utils": "/react-utils/static-2.5140",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "jasmine": "/jasmine/static-4.4092",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8241",
  "ai-rendering-library": "/ai-rendering-library/static-1.9183",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.54",
  "chirp-fetch": "/chirp-fetch/static-1.1645",
  "connections-embed-lib": "/connections-embed-lib/static-1.565",
  "copilot-toolkit": "/copilot-toolkit/static-1.10423",
  "foundations-assets": "/foundations-assets/static-1.4594",
  "hs-lodash": "/hs-lodash/static-4.45",
  "laboratory-lib": "/laboratory-lib/static-3.6925",
  "marketplace-embed": "/marketplace-embed/static-1.21376",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17378",
  "marketplace-ui-assets-core": "/marketplace-ui-assets-core/static-1.18782",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16252",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8741",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18801",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13016",
  "sanitize-text": "/sanitize-text/static-1.7902",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8456",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5509",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4781",
  "wootric-nps": "/wootric-nps/static-1.6737",
  "customer-data-objects": "/customer-data-objects/static-1.7405",
  "property-translator": "/property-translator/static-1.5176",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3713",
  "floating-ui": "/floating-ui/static-1.50",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1887",
  "hs-story-utils": "/hs-story-utils/static-1.9189",
  "react-aria": "/react-aria/static-1.60",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.93",
  "tanstack-table": "/tanstack-table/static-1.49",
  "trellis-assets": "/trellis-assets/static-1.1086",
  "ui-fonts": "/ui-fonts/static-1.446",
  "ui-images": "/ui-images/static-2.1082",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2654",
  "foundations-theming-base": "/foundations-theming-base/static-1.3156",
  "stylex": "/stylex/static-1.26",
  "flux-actions": "/flux-actions/static-1.302",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7689",
  "hs-promise-utils": "/hs-promise-utils/static-1.5353",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4641",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12705",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5346",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7551",
  "quartz-i18n": "/quartz-i18n/static-1.351",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10135",
  "reselect": "/reselect/static-2.16",
  "rxjs": "/rxjs/static-5.10",
  "sanitize": "/sanitize/static-1.4237",
  "superstore": "/superstore/static-1.4534",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9907",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7321",
  "hub-http-janus": "/hub-http-janus/static-1.784",
  "hubspotter-http": "/hubspotter-http/static-1.4444",
  "immer": "/immer/static-1.33",
  "immutable-less": "/immutable-less/static-1.4416",
  "nav-meta": "/nav-meta/static-1.28778",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.9999",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17593",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3642",
  "property-management-common": "/property-management-common/static-1.4449",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8803",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "icons": "/icons/static-2.618",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.474",
  "quartz-auth": "/quartz-auth/static-1.351",
  "quartz-head": "/quartz-head/static-1.341",
  "quartz-test": "/quartz-test/static-1.351",
  "usage-tracker-container": "/usage-tracker-container/static-1.7085",
  "csstype": "/csstype/static-1.50",
  "storybook-react": "/storybook-react/static-1.27",
  "trellis-story-utils": "/trellis-story-utils/static-1.4283",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4927",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "cssUtils": "/cssUtils/static-1.720",
  "HubStyle": "/HubStyle/static-2.11492",
  "bender-build-tools": "/bender-build-tools/static-1.2899",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20157",
  "ContentUtils": "/ContentUtils/static-1.67508",
  "sassPrefix": "/sassPrefix/static-1.151",
  "avatar-components": "/avatar-components/static-1.2248",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38739",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12764",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12903",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13370",
  "ExportDialog": "/ExportDialog/static-6.10150",
  "highlight.js": "/highlight.js/static-1.73",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40537",
  "reporting-data": "/reporting-data/static-1.66351",
  "reporting-snowflake": "/reporting-snowflake/static-1.54969",
  "reporting-ui-components": "/reporting-ui-components/static-2.63623",
  "reporting-visualizations": "/reporting-visualizations/static-1.58427",
  "ui-addon-teams": "/ui-addon-teams/static-1.21188",
  "magpie-lib": "/magpie-lib/static-1.5356",
  "magpie-types": "/magpie-types/static-1.4816",
  "simple-logging-lib": "/simple-logging-lib/static-1.2813",
  "navigation-components": "/navigation-components/static-1.17141",
  "navigation-messaging": "/navigation-messaging/static-1.6468",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10218",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7746",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3711",
  "signup-constants": "/signup-constants/static-1.18309",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7824",
  "ai-studio-lib": "/ai-studio-lib/static-1.10884",
  "ui-tool-access": "/ui-tool-access/static-1.9906",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7913",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5512",
  "usage-tracker-public": "/usage-tracker-public/static-1.6906",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4411",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.100",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2761",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "merchandise-lib": "/merchandise-lib/static-1.257",
  "atom": "/atom/static-1.4833",
  "purchase-motions-components": "/purchase-motions-components/static-1.5427",
  "salesImages": "/salesImages/static-1.520",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4270",
  "batch-promise": "/batch-promise/static-1.1312",
  "crm-component-utils": "/crm-component-utils/static-1.38386",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5634",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6632",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7852",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9381",
  "cms-field-types": "/cms-field-types/static-1.4569",
  "content-icons-ui": "/content-icons-ui/static-1.2141",
  "underscore": "/underscore/static-1.8",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7011",
  "crm-message-bus": "/crm-message-bus/static-1.42234",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21173",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9587",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4493",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3813",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6537",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.731",
  "onboarding-tours": "/onboarding-tours/static-1.16206",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reference-resolvers": "/reference-resolvers/static-1.7922",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12933",
  "academy-common-lib": "/academy-common-lib/static-1.12830",
  "content-assistance-lib": "/content-assistance-lib/static-1.7389",
  "dashboard-lib": "/dashboard-lib/static-1.80455",
  "file-manager-components": "/file-manager-components/static-1.22770",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17771",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17494",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17486",
  "prosemirror": "/prosemirror/static-1.13",
  "react-colorpicker": "/react-colorpicker/static-2.9974",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "rich-text-lib": "/rich-text-lib/static-1.19406",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8452",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4527",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10658",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8785",
  "user-context": "/user-context/static-1.4857",
  "persist-promise": "/persist-promise/static-1.3469",
  "reporting-client-types": "/reporting-client-types/static-1.2372",
  "growth-payments-core": "/growth-payments-core/static-1.24615",
  "highcharts": "/highcharts/static-8.98",
  "reporting-plugins": "/reporting-plugins/static-1.9933",
  "reporting-reports": "/reporting-reports/static-1.66029",
  "idb-keyval": "/idb-keyval/static-1.38",
  "reactive-lib": "/reactive-lib/static-1.488",
  "apps-service-types": "/apps-service-types/static-1.3641",
  "oauth-service-types": "/oauth-service-types/static-1.4002",
  "codemirror": "/codemirror/static-5.89",
  "feedback-loader": "/feedback-loader/static-1.28778",
  "react-codemirror": "/react-codemirror/static-1.10390",
  "onboarding-scopes": "/onboarding-scopes/static-1.6227",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4420",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7458",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14536",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3417",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8435",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4286",
  "nav-client-types": "/nav-client-types/static-1.2117",
  "purchase-motions-api": "/purchase-motions-api/static-1.5430",
  "trials-service-types": "/trials-service-types/static-1.3687",
  "card-properties-lib": "/card-properties-lib/static-1.43413",
  "crm-actions": "/crm-actions/static-1.6057",
  "crm-cards-data": "/crm-cards-data/static-1.1130",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.42798",
  "customer-data-properties": "/customer-data-properties/static-1.50666",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8710",
  "customer-data-tracking": "/customer-data-tracking/static-1.6644",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3589",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3930",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3484",
  "external-options-client-types": "/external-options-client-types/static-1.3949",
  "react-dnd-compat": "/react-dnd-compat/static-1.4385",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5116",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2832",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1257",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.272",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7288",
  "academy-service-client": "/academy-service-client/static-1.3444",
  "final-form": "/final-form/static-1.64",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27840",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8149",
  "immerable": "/immerable/static-1.3917",
  "video-components-external": "/video-components-external/static-1.10460",
  "video-data-lib": "/video-data-lib/static-1.34118",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8330",
  "payment-link-components": "/payment-link-components/static-1.22828",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9652",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23859",
  "viral-links-lib": "/viral-links-lib/static-1.6789",
  "data-token-picker": "/data-token-picker/static-1.15980",
  "FileManagerLib": "/FileManagerLib/static-1.38410",
  "react-flip-move": "/react-flip-move/static-1.64",
  "timezone-utils": "/timezone-utils/static-2.5006",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16889",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8168",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.152",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2968",
  "crm_data": "/crm_data/static-4.91089",
  "crm-links": "/crm-links/static-1.6016",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45308",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14857",
  "crm-fe-perf": "/crm-fe-perf/static-1.22669",
  "calling-global-api": "/calling-global-api/static-1.63527",
  "calling-internal-common": "/calling-internal-common/static-1.31053",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64909",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57203",
  "commerce-products-lib": "/commerce-products-lib/static-1.8735",
  "google-libphonenumber": "/google-libphonenumber/static-1.32",
  "hs-entities": "/hs-entities/static-1.432",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4016",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.396",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47842",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3753",
  "property-value-citations": "/property-value-citations/static-1.1280",
  "pulse": "/pulse/static-1.262",
  "smart-property-lib": "/smart-property-lib/static-1.5739",
  "tiered-pricing": "/tiered-pricing/static-1.773",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10757",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6347",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11310",
  "content-media-compositions": "/content-media-compositions/static-2.15317",
  "media-bridge-lib": "/media-bridge-lib/static-1.18502",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5663",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4851",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3439",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-3.69",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21244",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3605",
  "audio-components": "/audio-components/static-1.5554",
  "FileManagerCore": "/FileManagerCore/static-1.38269",
  "FileManagerImages": "/FileManagerImages/static-1.35921",
  "video-components": "/video-components/static-1.12463",
  "crm_universal": "/crm_universal/static-1.21596",
  "customer-data-email": "/customer-data-email/static-1.17603",
  "calling-error-reporting": "/calling-error-reporting/static-1.31059",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36396",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38751",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18389",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11020",
  "customer-data-content": "/customer-data-content/static-1.26806",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53880",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20778",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17019",
  "project-storage": "/project-storage/static-1.4495",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71015",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5261",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5094",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9466",
  "fsm": "/fsm/static-1.3494",
  "policy-lib": "/policy-lib/static-1.6547",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10800",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6301",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.122",
  "products-iframe-lib": "/products-iframe-lib/static-1.7211",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9765",
  "directed-graph": "/directed-graph/static-1.699",
  "event-emitter": "/event-emitter/static-1.710",
  "react-tinymce": "/react-tinymce/static-1.54516",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9529",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53642",
  "tinymce-plugins": "/tinymce-plugins/static-1.56756",
  "tinymce-themes": "/tinymce-themes/static-1.55612",
  "hls.js": "/hls.js/static-1.33",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4295",
  "video-embed": "/video-embed/static-1.34952",
  "social-insights-client-types": "/social-insights-client-types/static-1.21246",
  "sequences-lib": "/sequences-lib/static-1.7627",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10109",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17818",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36328",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9697",
  "utility-belt": "/utility-belt/static-1.2304",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21840",
  "products-ui-components": "/products-ui-components/static-1.39254",
  "quotes-client-types": "/quotes-client-types/static-1.37103",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.79734",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8845",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6665",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.53896",
  "commerce-products-api": "/commerce-products-api/static-1.1900",
  "SafeStorage": "/SafeStorage/static-1.4167",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.55954",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101691",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34899",
  "sales-views-client-types": "/sales-views-client-types/static-1.4054",
  "hub-http-contrib": "/hub-http-contrib/static-1.2807",
  "interframe": "/interframe/static-3.4554",
  "tinymce-data": "/tinymce-data/static-1.39727",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4975",
  "layout-dnd-components": "/layout-dnd-components/static-1.11961",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10936",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13677",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8862",
  "outpost": "/outpost/static-1.3969",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7484",
  "customer-data-associations": "/customer-data-associations/static-1.7097",
  "framework-data-table": "/framework-data-table/static-2.11325",
  "customer-data-rte": "/customer-data-rte/static-1.32353",
  "cv-backend-services": "/cv-backend-services/static-1.1484",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5304",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14124",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4875",
  "qrcode-generator": "/qrcode-generator/static-1.63",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7069",
  "commerce-permissions": "/commerce-permissions/static-1.514",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.268",
  "property-description-translator": "/property-description-translator/static-1.3622",
  "FireAlarmUi": "/FireAlarmUi/static-1.4293",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3959",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3427",
  "totals-ui-components": "/totals-ui-components/static-1.22902",
  "ContentData": "/ContentData/static-1.67583",
  "layout-data-lib": "/layout-data-lib/static-1.9261",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1111",
  "tanstack-virtual": "/tanstack-virtual/static-1.24",
  "draft-content-plugins": "/draft-content-plugins/static-1.27622",
  "stripe-connect-js": "/stripe-connect-js/static-1.63",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3604",
  "advanced-menus-core": "/advanced-menus-core/static-1.14758",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11741",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33324",
  "deal-intel-utils": "/deal-intel-utils/static-1.1115",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14757",
  "simple-menus-lib": "/simple-menus-lib/static-1.16274"
}
};
